<template>
  <section class="goodsdetail">
    <a :href="indexData.index_top_pull[0].url" target="_blank" rel="noopener noreferrer">
      <img :src="indexData.index_top_pull[0].src" alt srcset class="topguanggao" />
    </a>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword" :cartnum="cartnum"></Header>

    <div class="container">
      <div class="path flex">
        <!-- productdetail.categorypath -->
        <div class="miaobaoxie">
          <a href="#/">首页</a>
          <i class="iconfont icon-right"></i>
        </div>
        <!-- <div class="miaobaoxie" v-for="(item,index) in productdetail.categorypath" :key='index'>
          <a :href="'#/goodsList?categoryid='+item.id">{{item.name}}</a><i class="iconfont icon-right"></i>
        </div>-->
        <div class="miaobaoxie">
          {{productdetail.title}}
          <i class="iconfont icon-right"></i>
          {{selectedItemObj.keyname}}
        </div>
      </div>
      <div class="product-main">
        <div class="clearfix">
          <div class="product-imgshow">
            <div id="preview" class="spec-preview">
              <div class="jqzoom">
                <img
                  :jqimg="selectedItemObj.indexpic?selectedItemObj.indexpic:productdetail.indexpic"
                  :src="selectedItemObj.indexpic?selectedItemObj.indexpic:productdetail.indexpic"
                />
              </div>
            </div>
            <div class="spec-scroll">
              <a class="prev">
                <span class="iconfont icon-left"></span>
              </a>
              <a class="next">
                <span class="iconfont icon-right"></span>
              </a>
              <div class="items">
                <ul class="clearlist">
                  <li
                    v-for="(item,index) in productdetail.images"
                    class
                    :data-src="item.src"
                    :data-bigimg="item.src"
                    :key="index"
                    data-alt
                  >
                    <img :src="item.src" />
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex scfx">
              <div class="flex">
                <!-- <div href="javascript:;" class="soucan flex" @click="shoucang">
                  <span class="iconfont icon-star-h selected" v-if="productdetail.isfav==0"></span>
                  <span class="iconfont icon-star-h" v-else></span>
                  <span>{{productdetail.isfav==0?'收藏商品':'取消收藏'}}</span>
                </div>-->
              </div>
              <div class="social-share flex" data-sites="qzone, qq, weibo,wechat"></div>
            </div>
          </div>
          <div class="product-info">
            <div class="productname" v-html="productdetail.title">
              <span
                class="color-primary font-normal"
                v-if="productdetail.showsign"
              >({{productdetail.issign?'签约商品':'普通商品'}})</span>
            </div>
            <!-- <div class="childtitle" v-html="productdetail.content"></div> -->
            <div class="childtitle" style="margin:4px 0">{{productdetail.description}}</div>

            <!-- <div class="item color-primary" style="margin-top:10px;">
                 <span class="yuanjia ">原价 {{selectedItemObj.price1}}</span>
            </div>-->
            <div class="miaoshadDetail flex ju-be" v-if="productdetail.isgroup>0">
              <div>
                <span class="iconfont icon-time"></span>
                <span>快力文秒杀</span>
              </div>
              <div class="flex">
                <span v-if="productdetail.countdown==1">距离结束</span>
                <span v-if="productdetail.countdown==0">即将开始</span>
                <span v-if="productdetail.countdown==2">已结束</span>
                <span class="color-black">{{count_time[0]}}</span>:
                <span class="color-black">{{count_time[1]}}</span>:
                <span class="color-black">{{count_time[2]}}</span>
              </div>
            </div>

            <div class="jiage">
              <div class="item">
                <div class="tit" v-if="productdetail.isgroup>0">秒杀价</div>
                <div class="tit" v-else>价格</div>
                <div class="cont color-primary">
                  <span class="price color-red">{{selectedItemObj.price}}</span>
                  <span class="color-red">积分</span>
                </div>
              </div>
              <div class="item">
                <div class="yuanjia">
                  <div class="tit" style="font-size:12px">原价</div>
                  <span class="goodsyuanjia">
                    <span style="font-size: 12px;">￥</span>
                    {{selectedItemObj.price1}}
                  </span>
                </div>
              </div>
              <div class="pingjia">
                <span class="yuanjia">累计评价</span>
                <br />
                <span class="num color-primary">{{goodscommont.total}}</span>
              </div>
              <!-- <div class="item">
								<div class="tit">优惠</div>
								<div class="cont color-primary">可使用满1000减200抵用券</div>
              </div>-->
            </div>
            <div class="info flex">
              <div class="item">
                库存
                <span class="color-primary">{{selectedItemObj.stock}}</span>
              </div>
              <div class="item">
                销量
                <span class="color-primary">{{selectedItemObj.sold}}</span>
              </div>
              <div class="item">{{productdetail.templateid==0?'包邮':'有运费'}}</div>
            </div>
            <div class="canshu" v-if="ismulti">
              <div class="item" v-for="(item,index) in productdetail.speclist" :key="index">
                <div class="tit">{{item.name}}：</div>
                <div class="cont">
                  <ul class="clearlist clearfix">
                    <li
                      :faid="item.id"
                      :id="item_i[0]"
                      :class="item_i[0]==selectedItemArr[index]?'active':''"
                      @click="specification(item.id,item_i[0])"
                      v-for="(item_i) in item.child"
                      :key="item_i.id"
                    >
                      <a href="javascript:;">{{item_i[1]}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="shuliang flex">
              <div class="tit">数量</div>
              <div class="numbers">
                <input type="text" min="0" v-model="num" />
                <div class="jiajian">
                  <a href="javascript:;" @click="changeNum('add',selectedItemObj.stock)">
                    <i class="iconfont icon-up"></i>
                  </a>
                  <a href="javascript:;" @click="changeNum('reder',selectedItemObj.stock)">
                    <i class="iconfont icon-down"></i>
                  </a>
                </div>
              </div>
              <div>{{productdetail.unit}}</div>
              <el-button type="success" plain class="kefu">
                <span class="iconfont icon-kefu" style="font-size:18px"></span>
                <a
                  href="http://p.qiao.baidu.com/cps/chat?siteId=1879354&userId=5484040"
                  target="_blank"
                  rel="noopener noreferrer"
                >在线客服</a>
              </el-button>
            </div>
            <div class="btnbox">
              <a href="javascript:;" class="layui-btn" @click="goBuy">立即购买</a>
              <!-- <a
                href="javascript:;"
                class="layui-btn layui-btn-primary"
                @click="addCar"
                v-if="productdetail.isgroup==0"
              >加入购物车</a>-->
            </div>
          </div>
        </div>
        <div class="product-side">
          <div class="product-title" style="border:none">
            <h2 style="width:200px;box-sizing:border-box">推荐商品</h2>
          </div>
          <div class="liulanjilu">
            <ul class="clearlist">
              <li v-for="(item,index) in CanAgincan.data" :key="index">
                <a :href="'#/goodsdetail?id='+item.id" target="_blank">
                  <div class="img">
                    <img :src="item.indexpic" />
                  </div>
                  <div class="name">{{item.title}}</div>
                  <div class="price">{{item.price}}积分</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="fl" style="width:800px;">
          <div class="product-title">
            <h2 class="active" style="width:200px;box-sizing:border-box">商品详情</h2>
            <h2>
              <el-badge :value="goodscommont.total" class="item">商品评价</el-badge>
            </h2>
            <h2>物流信息</h2>
          </div>
          <div class="product-content" id="preview">
            <div class="pt-item goodsdetail">
             
              <div v-html="productdetail.content"></div>
            </div>

            <div class="pt-item hide">
              <div v-if="goodscommont.data.length>0">
                <div class="plbox" v-for="(item) in goodscommont.data" :key="item.id">
                  <div class="pl-hd">
                    <div class="pl-touxiang">
                      <img :src="item.headimgurl||'/static/images/avatar.jpg'" />
                    </div>
                    <div class="name">{{item.nickname}}</div>
                  </div>
                  <div class="pl-bd">
                    <div>
                      <span :class="'star star0'+item.star"></span>
                    </div>
                    <div>{{item.remark}}</div>
                    <div class="pl-img" style="width:160px">
                      <div class="clearfix imgtab">
                        <img
                          v-for="(item_i,index) in item.photos"
                          :key="index"
                          :src="item_i"
                          @click="previewImg(item_i)"
                        />
                      </div>
                      <div class="bigcpimg hide">
                        <a href="javascript:;" class="close">
                          <span class="iconfont icon-up"></span>
                          收起
                        </a>
                        <a href="javascript:;" class="btnprev">
                          <span class="iconfont icon-left"></span>
                        </a>
                        <a href="javascript:;" class="btnnext">
                          <span class="iconfont icon-right"></span>
                        </a>
                        <img class="img" src />
                      </div>
                    </div>
                    <div class="pl-info">{{item.addtime}}</div>
                  </div>
                </div>
                <el-pagination
                  class="fenye"
                  background
                  layout="prev, pager, next"
                  :page-size="goodscommont.per_page"
                  @current-change="currentcommont"
                  :total="goodscommont.total"
                ></el-pagination>
              </div>
              <div v-else>暂无数据</div>
            </div>
            <div class="pt-item hide">
              <div class v-if="productdetail.expressinfo" v-html="productdetail.expressinfo"></div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kuaijiemenu">
      <a :href="indexData.index_kefu" target="_blank" class="active">
        <li class="center">
          <span class="iconfont icon-lianxi"></span>
          <span>在线</span>
          <span>咨询</span>
        </li>
      </a>
      <a href="#/cart" class="car">
        <el-tooltip class="item" effect="dark" content="购物车" placement="left">
          <li class="center">
            <span class="iconfont icon-cart"></span>
            <span class="carnum">{{cartnum}}</span>
          </li>
        </el-tooltip>
      </a>
      <a href="javascript:;" class @click="yijian">
        <el-tooltip class="item" effect="dark" content="意见反馈" placement="left">
          <li class="center">
            <span class="iconfont icon-edit"></span>
          </li>
        </el-tooltip>
      </a>
      <a href="javascript:;" class @click="toTop">
        <li class="center">
          <span class="iconfont icon-up"></span>
        </li>
      </a>
    </div>
    <el-dialog title="意见反馈" :visible.sync="adviceFormVisible" destroy-on-close>
      <Advice @fatherMethod="closeAdviceBox"></Advice>
    </el-dialog>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
import Advice from "../components/advice";
import Share from "vue-social-share";
layui.use(["layer"], function() {
  layer = layui.layer;
});
export default {
  components: {
    Header,
    Share,
    Advice,
    Footer
  },
  name: "goodsdetail",
  data() {
    return {
      str: "",
      num: 1,
      page: 1,
      adviceFormVisible: false,
      cartnum: 0,
      goodscommont: { data: [] },
      id: getParameterByName("id"),
      specification_S: getParameterByName("specification"),
      guid: sessionStorage.guid,
      productdetail: { params: [] }, //产品详情的数据
      ismulti: false, //是否是多规格
      CanAgincan: {}, //看了又看的商品
      selectedItemArr: [],
      autotroph: sessionStorage.autotroph,
      selectedItemObj: {},
      indexData: { index_top_pull: [{ url: "", src: "" }] },
      keyword: decodeURI(getQueryVariable("keyword")),
      userInfo: {},
      count_time: ["00", "00", "00"],
      cainixihuan: {}
    };
  },
  methods: {
  
    // 封装获取数据的方法
    async getProductdetail() {
      let that = this;
      let res = await this.$fetch("shop/giftdetail", {
        body: { id: this.id }
      });
   
      if (res === false) {
        this.$confirm("此商品已下架或被删除，请浏览其他商品", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: false,
          type: "warning"
        })
          .then(() => {
            this.$router.push("/");
          })
          .catch(() => {});
      }
      if (res.images) {
        res.images = JSON.parse(res.images);
      }
      res.sold = res.sold + res.soldinit + res.solds;
      this.ismulti = res.ismulti;
      let obj = {
        indexpic: res.indexpic,
        sold: res.sold + res.soldinit + res.solds,
        stock: res.stock,
        price: res.price,
        price1: res.price1,
        title: res.title
      };

      if (res.ismulti == 1) {
        this.ismulti = true;
        obj.stock = res.stocks;
        // 删除没有属性值的属性
        res.speclist = res.speclist.filter(item => item.child.length > 0);
        for (let key in res.speclist) {
          this.selectedItemArr.push(res.speclist[key].child[0][0]);
        }
        for (let key in res.specvalue) {
          if (this.selectedItemArr.join("_") == key) {
            obj = res.specvalue[key];
            obj["id"] = key;
          }
        }
        // 判断是否有 默认的规格
        if (this.specification_S) {
          for (let key in res.specvalue) {
            if (this.specification_S == key) {
              obj = res.specvalue[key];
              obj["id"] = key;
              this.selectedItemArr = key.split(",");
            }
          }
        }
      }
      this.selectedItemObj = obj;
      this.productdetail = res;
    },
    // 看了又看的商品
    async getCanAgincan() {
      this.CanAgincan = await this.$fetch("shop/giftlist", {
        body: {
          pid: this.productdetail.pid,
          page: 1,
          size: 5
        }
      });
    },
    // 点击切换规格
    specification(faItem, id) {
      let speclist = this.productdetail.speclist;
      let isAll = true;
      for (let i = 0; i < speclist.length; i++) {
        if (faItem == speclist[i].id) {
          this.selectedItemArr[i] = id;
        }
      }
      // 判断是否选全了规格
      for (let i = 0; i < speclist.length; i++) {
        if (!speclist[i]) {
          isAll = false;
        }
      }
      if (isAll) {
        let specvalue = this.productdetail.specvalue;
        let str = this.selectedItemArr.join("_");
        for (let key in specvalue) {
          if (key == str) {
            let obj = specvalue[key];
            obj["id"] = key;
            this.selectedItemObj = obj;
            console.log(this.selectedItemObj);
          }
        }
      }
    },

    // 点击立即购买按钮
    async goBuy() {
      let submitorder = this.selectedItemObj;
      if (this.num > submitorder.stock) {
        layer.alert("不能超过最大库存", { icon: 2 });
        return;
      }
      if (!this.guid) {
        this.$router.push("/login");
        return;
      }
      this.$router.push({
        path: "/jiesuan",
        query: {
          productid: this.id,
          jifen: true,
          num: this.num
        }
      });
      
    },
   
    // 修改数量
    changeNum(type, stock) {
      let num = Number(this.num);
      if (type == "add") {
        if (num >= stock) {
          return;
        }
        this.num = num + 1;
      } else {
        if (num <= 1) {
          this.num = 1;
          return;
        }
        this.num = num - 1;
      }
    },
    // 获取商品评价
    async getgoodscommont() {
      this.goodscommont = await this.$fetch("shop/commentlist", {
        body: { productid: this.productdetail.id }
      });
      for (let i = 0; i < this.goodscommont.data.length; i++) {
        if (this.goodscommont.data[i].photos) {
          this.goodscommont.data[i].photos = JSON.parse(
            this.goodscommont.data[i].photos
          );
        } else {
          this.goodscommont.data[i].photos = [];
        }
      }
    },
    // 意见反馈
    yijian() {
      this.adviceFormVisible = true;
    },
    closeAdviceBox() {
      this.adviceFormVisible = false;
    },
    toTop() {
      let num = document.documentElement.scrollTop;
      let timeiD = setInterval(function() {
        num = num - 100;
        document.documentElement.scrollTop = num;
        console.log(num);
        if (num <= 0) {
          clearInterval(timeiD);
        }
      }, 20);
    },
    // 点击 预览图片
    previewImg(obj) {
      var img = new Image();
      img.src = obj.src;
      var imgHtml = "<img src='" + obj + "' />";
      //捕获页
      layer.open({
        type: 1,
        shade: false,
        title: false, //不显示标题
        //  area: [600+'px', 480+'px'],
        content: imgHtml, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
        cancel: function() {
          //layer.msg('捕获就是从页面已经存在的元素上，包裹layer的结构', { time: 5000, icon: 6 });
        }
      });
    },
    currentcommont(e) {
      this.page = e;
      this.getgoodscommont();
    }
  },
  destroyed() {
    clearInterval(this.timeId);
  },
  async mounted() {
    this.indexData = await this.$fetch("Index/indexdata");
    this.cartnum = this.indexData.index_cartnum;
    await this.getProductdetail();
    this.getCanAgincan();
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    this.getgoodscommont();
    // 一些配置
    $(".nav-service").hover(
      function() {
        $(this)
          .find(".downmenu")
          .slideDown("fast");
      },
      function() {
        $(this)
          .find(".downmenu")
          .stop()
          .slideUp("fast");
      }
    );
    layui.use(["laypage"], function() {
      var laypage = layui.laypage;
      laypage.render({
        elem: "fenye",
        count: 100,
        layout: ["prev", "page", "next", "count", , "skip"],
        jump: function(obj) {
          // console.log(obj);
        }
      });
    });
    $(".product-title h2").on("click", function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      $(".product-content .pt-item")
        .eq($(this).index())
        .removeClass("hide")
        .siblings()
        .addClass("hide");
    });
    $.each($(".pl-img"), function() {
      var _this = $(this);
      _this.find(".imgtab a").on("click", function() {
        $(this)
          .addClass("active")
          .siblings()
          .removeClass("active");
        _this.find(".bigcpimg").removeClass("hide");
        _this.find(".bigcpimg .img").attr("src", $(this).attr("href"));
        return false;
      });
      _this.find(".bigcpimg .close").on("click", function() {
        _this.find(".bigcpimg").addClass("hide");
        _this.find(".imgtab a").removeClass("active");
      });
      _this.find(".bigcpimg .btnprev").on("click", function() {
        if (_this.find(".imgtab a.active").index() > 0) {
          _this.find(".bigcpimg .img").attr(
            "src",
            _this
              .find(".imgtab a")
              .eq(_this.find(".imgtab a.active").index() - 1)
              .attr("href")
          );
          _this
            .find(".imgtab a")
            .eq(_this.find(".imgtab a.active").index() - 1)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }
      });
      _this.find(".bigcpimg .btnnext").on("click", function() {
        if (
          _this.find(".imgtab a.active").index() <
          _this.find(".imgtab a").length - 1
        ) {
          _this.find(".bigcpimg .img").attr(
            "src",
            _this
              .find(".imgtab a")
              .eq(_this.find(".imgtab a.active").index() + 1)
              .attr("href")
          );
          _this
            .find(".imgtab a")
            .eq(_this.find(".imgtab a.active").index() + 1)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }
      });
    });
    $(".canshu li").on("click", function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
    });
  }
};
</script>

  


<style lang='scss' scoped>
.goodsdetail {
  background: #fff !important;
}
.topguanggao {
  width: 100%;
}
.el-carousel__item {
  height: 450px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators {
  .el-carousel__indicator {
    margin-right: 10px !important;
  }
}
.kefu {
  margin-left: 30px;
  padding: 6px 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jifengoods_detail.vue